import React from "react";

type PageSectionProps = {
  className?: string;
  isPadded?: boolean;
  children: React.ReactNode;
};

const PageSection = ({
  className,
  isPadded = true,
  children,
}: PageSectionProps) => {
  return (
    <div className={`page-section ${isPadded && "px-4"} ${className}`}>
      {children}
    </div>
  );
};

export default PageSection;
